<mat-form-field appearance="outline" class="company-field">
  <mat-label>{{ label }}</mat-label>
  <mat-icon matPrefix>search</mat-icon>
  <input
    matInput
    [(ngModel)]="selection"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    [disabled]="disabled"
    (blur)="onBlur()"
  />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCompany" (optionSelected)="onOptionSelected($event.option.value)">
    @for (c of filtered; track c.companyId) {
      <mat-option [value]="c">{{ c.companyName }} ({{ c.countryCode }})</mat-option>
    } @empty {
      <mat-option disabled>No companies match.</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
